import React, { useState } from 'react'
import { Form, Input, Modal, Radio } from 'antd'
import { IconCloseOutlined, IconHelpCircle, IconLetter, Button } from '@tutorbot/ui-components'
import './ModalContent.css'
import { emailAddress, clientName, clientToken } from '../../Gateway/FormInputs'

const uploadConfirmation = (file, handleSubmit, handleReset) => {
  return (
    Modal.confirm({
      title: 'Upload confirmation',
      icon: <IconHelpCircle fill='var(--warning-color)' size={'sm'} />,
      content: (<p>Please confirm this file upload. <span className='text_color'>{file.name}</span></p>),
      className: 'modal_dialog',
      centered: true,
      okText: 'Upload',
      cancelText: 'Cancel',
      onOk: handleSubmit,
      onCancel: handleReset
    })
  )
}

const uploadSuccessfulConfirmation = (fileName, handleSubmit = () => {}) => {
  return (
    Modal.confirm({
      title: 'Upload Successful',
      icon: <IconHelpCircle fill='var(--warning-color)' size={'sm'} />,
      content: (<p>The file <span className='text_color'>{fileName}</span> successful uploaded.</p>),
      className: 'modal_dialog',
      centered: true,
      okText: 'Ok',
      onOk: handleSubmit
    })
  )
}

const uploadDataConfirmation = (handleOpenFileInput, handleReset) => {
  return (
    Modal.confirm({
      title: 'Upload data',
      icon: <IconHelpCircle fill='var(--warning-color)' size={'sm'} />,
      content: <p>To start making use of the analytics tools you will need to upload your first sample of data.</p>,
      className: 'modal_dialog',
      centered: true,
      okText: 'Upload data',
      cancelText: 'Upload later',
      onOk: handleOpenFileInput,
      onCancel: handleReset
    })
  )
}

const uploadUnsuccessfulConfirmation = (fileName, handleOpenFileInput, handleReset) => {
  return (
    Modal.confirm({
      title: 'Upload unsuccessful',
      icon: <IconHelpCircle fill='var(--warning-color)' size={'sm'} />,
      content: (
                <div className='modal_content'>
                    <p>The file below failed to upload successfully. <span className='text_color'>{fileName}</span></p>
                    <p>Failure could be due to one of the following:</p>
                    <ul className='reason_list'>
                        <li>Incorrect file type</li>
                        <li>Incorrect data format</li>
                        <li>Corrupt file</li>
                    </ul>
                    <p>Check the file upload guide for help.
                        <span className='text_color'>
                            <a className='guide_label' href='/'>Data upload guide</a>
                        </span>
                    </p>
                </div>
      ),
      className: 'modal_dialog',
      centered: true,
      okText: 'Re-upload',
      cancelText: 'Cancel',
      onOk: handleOpenFileInput,
      onCancel: handleReset
    })
  )
}

const userInvitationDialog = (
  onSubmit,
  form,
  handleReset,
  inputField,
  handleInputChange,
  email
) => {
  return (
    Modal.confirm({
      title: 'Add new user',
      icon: <IconHelpCircle fill='var(--warning-color)' size={'sm'} />,
      content: (
                <div className='modal_content new_user_dialog'>
                    <p>Enter the email address of the new user below.</p>
                    <div>
                        <Form
                            name='form'
                            form={form}
                            layout="vertical"
                            validateTrigger="onBlur"
                            className="form"
                            onFinish={onSubmit}
                            initialValues={{ }}
                        >
                            <Form.Item
                                name={emailAddress.fieldName}
                                label={emailAddress.name}
                                rules={[
                                  {
                                    validator (_, value) {
                                      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                      if (!value) {
                                        return Promise.reject(
                                          new Error('Please enter email address')
                                        )
                                      }
                                      if (pattern.test(value)) {
                                        return Promise.resolve()
                                      }
                                      return Promise.reject(
                                        new Error('You have entered an invalid email address')
                                      )
                                    }
                                  }
                                ]}
                            >
                                <Input
                                    ref={inputField}
                                    className='add_new_user_input'
                                    value={email}
                                    onChange={(e) => handleInputChange(e)}
                                    prefix={<IconLetter fill={'var(--black-40)'} size={'sm'} />}
                                    placeholder={emailAddress.placeholder}
                                    type={emailAddress.type}
                                    autoComplete='off'
                                />
                            </Form.Item>
                            <Form.Item>
                                <div className="add-dialog-buttons">
                                    <Button htmlType={'reset'} type={'default'} className={'cancel_btn'} onClick={() => Modal.destroyAll()}>
                                        Cancel
                                    </Button>
                                    <Button htmlType={'submit'} type={'primary'} className={'add_btn'} >Add</Button>
                                </div>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
      ),
      cancelButtonProps: { style: { display: 'none' } },
      okButtonProps: { style: { display: 'none' } },
      className: 'modal_dialog create_user',
      centered: true
    })
  )
}

const globalErrorAlert = (errors) => {
  return (
    Modal.info({
      title: 'Unexpected error',
      icon: <IconCloseOutlined size={'sm'} fill={'var(--error-color)'} />,
      content: (
        <div className='modal_content'>
          <p>Failure could be due to one of the following:</p>
          <ul className='reason_list'>
            {errors.map((item, i) =>
              <li key={i}>{item}</li>
            )}
          </ul>
        </div>
      ),
      className: 'modal_dialog global_error_dialog',
      centered: true,
      closable: false
    })
  )
}

const Alert = (title, content, icon, onOk = () => {}, closable = false) => {
  return (
    Modal.info({
      title: title,
      icon: icon,
      content: content,
      className: 'modal_dialog alert',
      centered: true,
      okText: 'Ok',
      closable,
      onOk: onOk
    })
  )
}

const resetPasswordConfirmation = (userName, handlePasswordReset = () => {}, handleReset = () => {}) => {
  return (
    Modal.confirm({
      title: 'Reset password',
      icon: <IconHelpCircle fill='var(--warning-color)' size={'sm'} />,
      content: (<p>Are you sure you want to reset this users password?
                <span className='text_color'>{userName}</span></p>
      ),
      className: 'modal_dialog reset_password',
      centered: true,
      okText: 'Reset',
      cancelText: 'Cancel',
      onOk: handlePasswordReset,
      onCancel: handleReset
    })
  )
}

const userDeleteConfirmation = (userName, handleUserDelete = () => {}, handleReset = () => {}) => {
  return (
    Modal.confirm({
      title: 'Delete confirmation',
      icon: <IconCloseOutlined fill='var(--error-color)' size={'sm'} />,
      content: (<p>Are you sure you wish to permanently delete this user?
                <span className='text_color'>{userName}</span></p>
      ),
      className: 'modal_dialog delete_user',
      centered: true,
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: handleUserDelete,
      onCancel: handleReset
    })
  )
}

const userRoleChangeConfirmation = (userName, handleUserRoleChange = () => {}, handleReset = () => {}) => {
  return (
    Modal.confirm({
      title: 'Role change',
      icon: <IconHelpCircle fill='var(--warning-color)' size={'sm'} />,
      content: (<p>Are you sure you want to change this users role and permissions?
                <span className='text_color'>{userName}</span></p>
      ),
      className: 'modal_dialog change_role',
      centered: true,
      okText: 'Change',
      cancelText: 'Cancel',
      onOk: handleUserRoleChange,
      onCancel: handleReset
    })
  )
}

const logOutDialog = (handleOk, handleCancel) => {
  return (
    Modal.confirm({
      title: 'Log out',
      icon: <IconHelpCircle fill='var(--warning-color)' size={'sm'} />,
      content: <p>Are you sure you wish to log out?</p>,
      className: 'modal_dialog log_out',
      centered: true,
      okText: 'Log out',
      cancelText: 'Cancel',
      onOk: handleOk,
      onCancel: handleCancel
    })
  )
}

const ConditionalInput = () => {
  const [value, setValue] = useState('false')
  return (
    <>
      <Form.Item
          label={clientToken.name}
          name="autoGenerate"
          initialValue={value}
        >
        <Radio.Group onChange={e => setValue(e.target.value)}>
          <Radio value="false">Auto Generate</Radio>
          <Radio value="true">Custom</Radio>
        </Radio.Group>
      </Form.Item>
      {value === 'true' && (
        <Form.Item
          name={clientToken.fieldName}
          rules={clientToken.rules}
        >
          <Input
            className='add_client_token'
            placeholder={clientToken.placeholder}
            type={clientToken.type}
            autoComplete='off'
          />
        </Form.Item>
      )}
    </>
  )
}

const addNewClientModal = (
  onSubmit,
  form
) => {
  return (
    Modal.confirm({
      title: 'Add new client',
      icon: <IconHelpCircle fill='var(--primary-color)' size={'sm'} />,
      content: (
        <div className='modal_content'>
          <div>
            <Form
              name='form'
              form={form}
              layout="vertical"
              validateTrigger="onBlur"
              className="form"
              onFinish={onSubmit}
              initialValues={{ autoGenerate: 'false' }}
              wrapperCol={{ flex: 1 }}
            >
              <Form.Item
                name={clientName.fieldName}
                label={clientName.name}
                rules={clientName.rules}
              >
                <Input
                  className='add_client_name'
                  placeholder={clientName.placeholder}
                  type={clientName.type}
                  autoComplete='off'
                />
              </Form.Item>
              <ConditionalInput />
              <Form.Item>
                <div className="add-dialog-buttons">
                  <Button htmlType={'reset'} type={'default'} className={'cancel_btn'} onClick={() => Modal.destroyAll()}>
                    Cancel
                  </Button>
                  <Button htmlType={'submit'} type={'primary'} className={'add_btn'}>
                    Add
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      ),
      className: 'modal_dialog add_new_clients',
      cancelButtonProps: { style: { display: 'none' } },
      okButtonProps: { style: { display: 'none' } },
      centered: true
    })
  )
}

const tokenDeleteConfirmation = (handleTokenDelete = () => {}, handleReset = () => {}) => {
  return (
    Modal.confirm({
      title: 'Delete confirmation',
      icon: <IconCloseOutlined fill='var(--error-color)' size={'sm'} />,
      content: (<p>Are you sure you want to delete this token?</p>
      ),
      className: 'modal_dialog delete_token',
      centered: true,
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: handleTokenDelete,
      onCancel: handleReset
    })
  )
}

export {
  uploadConfirmation,
  uploadDataConfirmation,
  uploadUnsuccessfulConfirmation,
  uploadSuccessfulConfirmation,
  userInvitationDialog,
  globalErrorAlert,
  Alert,
  resetPasswordConfirmation,
  userDeleteConfirmation,
  userRoleChangeConfirmation,
  logOutDialog,
  addNewClientModal,
  tokenDeleteConfirmation
}
